/* Refinish Hub — scroll reveal
   Adds .is-in to matching elements as they enter view.
   Bails out entirely if the browser lacks IntersectionObserver or the visitor
   has asked for reduced motion, leaving all content visible.

   Keep SEL in step with the selector lists in rh-reveal.css. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var SEL = [
    '[data-rh-reveal]',
    '[data-rh-reveal-stagger]',
    '.rh-hl',
    '.rh-clips',
    '.rh-hl__points',
    '.rh-clips__marques'
  ].join(', ');

  // Only hide things once we know we can reveal them again.
  document.documentElement.classList.add('rh-reveal-on');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.12
  });

  function observeAll(scope) {
    var nodes = (scope || document).querySelectorAll(SEL);
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.rhObserved) return;
      el.dataset.rhObserved = '1';
      // Anything already on screen at load reveals immediately.
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        el.classList.add('is-in');
        return;
      }
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });

  // Safety net: reveal everything after 6s in case something never intersects.
  window.setTimeout(function () {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) {
      el.classList.add('is-in');
    });
  }, 6000);
})();
